import {
  Badge,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@stocks/ui";
import type { ItemCategory } from "@stocks/shared";

import { formatOrderQuantity } from "../lib/format";

export interface MaterialRow {
  itemId: string;
  itemCode: string;
  itemName: string;
  itemSpec: string | null;
  itemCategory: ItemCategory | null;
  baseUnit: string;
  required: string | number;
  available: string | number;
  shortage: string | number;
}

/** 필요 자재 · 가용 · 부족 수량 표 (입력 중 계산 / 서버 계산 결과 공용) */
export const MaterialsTable = ({
  rows,
  emptyText = "계산할 자재가 없습니다.",
}: {
  rows: MaterialRow[];
  emptyText?: string;
}) => (
  <Table>
    <TableHeader>
      <TableRow>
        <TableHead>코드</TableHead>
        <TableHead>자재</TableHead>
        <TableHead className='text-right'>필요 수량</TableHead>
        <TableHead className='text-right'>가용 수량</TableHead>
        <TableHead className='text-right'>부족 수량</TableHead>
        <TableHead>상태</TableHead>
      </TableRow>
    </TableHeader>
    <TableBody>
      {rows.length === 0 && (
        <TableRow>
          <TableCell colSpan={6} className='text-center text-muted-foreground'>
            {emptyText}
          </TableCell>
        </TableRow>
      )}
      {rows.map((r) => {
        const short = Number(r.shortage) > 0;
        return (
          <TableRow key={r.itemId}>
            <TableCell>{r.itemCode}</TableCell>
            <TableCell>
              <div className='font-medium'>{r.itemName}</div>
              {r.itemSpec && (
                <div className='text-xs text-muted-foreground'>{r.itemSpec}</div>
              )}
            </TableCell>
            <TableCell className='text-right'>
              {formatOrderQuantity(r.required)} {r.baseUnit}
            </TableCell>
            <TableCell className='text-right'>
              {formatOrderQuantity(r.available)} {r.baseUnit}
            </TableCell>
            <TableCell
              className={`text-right ${short ? "font-semibold text-destructive" : ""}`}
            >
              {formatOrderQuantity(r.shortage)} {r.baseUnit}
            </TableCell>
            <TableCell>
              <Badge variant={short ? "destructive" : "outline"}>
                {short ? "부족" : "충분"}
              </Badge>
            </TableCell>
          </TableRow>
        );
      })}
    </TableBody>
  </Table>
);
